import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn, PaletteUtils } from '@shared/utils';
import { TravelForm } from './travelForm';
import { RequestSubmittedModal } from './requestSubmittedModal';
import { Text } from '@shared/widgets';

interface TravelRequestProps {
  className?: string;
}

export const TravelRequest = (props: TravelRequestProps) => {
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);

  const { t } = useTranslation('travel');

  return (
    <section
      className={cn(
        'flex flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <div className='flex flex-col gap-2'>
        <Text tag='h2' weight='semibold' size='2xl'>
          {t('travelRequest.title')}
        </Text>
        <Text tag='p' color='gray'>
          {t('travelRequest.description')}
        </Text>
      </div>
      <TravelForm onSubmit={() => setShowSuccessModal(true)} />
      <RequestSubmittedModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} />
    </section>
  );
};
